// 配置路由相关信息
import VueRouter from 'vue-router'
import Vue from 'vue'
import store from '../store/index'

const Login = () => import('../views/Login.vue')
const Register = () => import('../views/Register.vue')
// 陪护服务验证
const EscortVerify = () => import('../views/EscortVerify.vue')
const Home = () => import('../views/Home.vue')
const Escort = () => import('../views/Escort.vue')
const Management = () => import('../views/Management.vue')
const Personal = () => import('../views/Personal.vue')
// 新增组件引入
const ManagementIndex = () => import('../views/Management/ManagementIndex.vue')
const OrderIndex = () => import('../views/Management/OrderCenter/OrderIndex.vue')
const OrderDispatchIndex = () => import('../views/Management/OrderCenter/OrderDispatchIndex.vue')
const OrderList = () => import('../views/Management/OrderCenter/OrderList.vue')
const OrderDetail = () => import('../views/Management/OrderCenter/OrderDetail.vue')
const OrderDetailDispatch = () => import('../views/Management/OrderCenter/OrderDetailDispatch.vue')
// 代拿报告
const OrderReportDetail = () => import('../views/Management/OrderCenter/OrderReportDetail.vue')
const OrderReportDetailDispatch = () => import('../views/Management/OrderCenter/OrderReportDetailDispatch.vue')
// 代配药
const MedicineDispatchDetail = () => import('../views/Management/OrderCenter/MedicineDispatchDetail.vue')
const MedicineDispatchDetailDispatch = () => import('../views/Management/OrderCenter/MedicineDispatchDetailDispatch.vue')
// 代问诊
const InquiryAgencyDetail = () => import('../views/Management/OrderCenter/InquiryAgencyDetail.vue')
const InquiryAgencyDetailDispatch = () => import('../views/Management/OrderCenter/InquiryAgencyDetailDispatch.vue')
// 预约检查
const AppointmentCheckDetail = () => import('../views/Management/OrderCenter/AppointmentCheckDetail.vue')
const AppointmentCheckDetailDispatch = () => import('../views/Management/OrderCenter/AppointmentCheckDetailDispatch.vue')
// 代办住院/出院
const InHospitalDetail = () => import('../views/Management/OrderCenter/InHospitalDetail.vue')
const InHospitalDetailDispatch = () => import('../views/Management/OrderCenter/InHospitalDetailDispatch.vue')
// 代办入院/出院
const InHospitalInDetail = () => import('../views/Management/OrderCenter/InHospitalInDetail.vue')
const InHospitalInDetailDispatch = () => import('../views/Management/OrderCenter/InHospitalInDetailDispatch.vue')


const BusinessAreaManagement = () => import('../views/Management/BusinessAreaManagement/BusinessAreaManagement.vue')
const BusinessAreaList = () => import('../views/Management/BusinessAreaManagement/BusinessAreaList.vue')
const EditStreetManagement = () => import('../views/Management/BusinessAreaManagement/EditStreetManagement.vue')
const EditCommunityManagement = () => import('../views/Management/BusinessAreaManagement/EditCommunityManagement.vue')
const EditResCommunityManagement = () => import('../views/Management/BusinessAreaManagement/EditResCommunityManagement.vue')
const EditCooperationManagement = () => import('../views/Management/BusinessAreaManagement/EditCooperationManagement.vue')
const EditServiceAreaManagement = () => import('../views/Management/BusinessAreaManagement/EditServiceAreaManagement.vue')
// 服务收费管理
const ServiceChargeManagement = () => import('../views/Management/ServiceChargeManagement/ServiceChargeManagement.vue')
// 编辑服务收费
const EditServiceCharge = () => import('../views/Management/ServiceChargeManagement/EditServiceCharge.vue')

// 器材收费管理
const EquipmentChargeManagement = () => import('../views/Management/EquipmentChargeManagement/EquipmentChargeManagement.vue')
// 编辑器材收费
const EditEquipmentCharge = () => import('../views/Management/EquipmentChargeManagement/EditEquipmentCharge.vue')

// 服务合作机构管理
const ServiceCooperationManagement = () => import('../views/Management/ServiceCooperationManagement/ServiceCooperationManagement.vue')
// 编辑服务合作机构
const EditServiceCooperation = () => import('../views/Management/ServiceCooperationManagement/EditServiceCooperation.vue')

// 安装插件
Vue.use(VueRouter)

// 创建VueRouter对象
const routes = [
    {
        path: '/',
        name: 'Login',
        redirect: '/login',
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    // 陪护服务验证
    {
        path: '/escort-verify',
        name: 'EscortVerify',
        component: EscortVerify,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {}, // 不需要身份验证
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true, // 表示需要身份验证
        },
        children: [
            {
                path: 'escort',
                name: 'Escort',
                component: Escort,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'management',
                name: 'Management',
                component: Management,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'personal',
                name: 'Personal',
                component: Personal,
                meta: {
                    requireAuth: true
                }
            }
        ]
    },
    {
        path: '/OrderIndex',
        name: 'OrderIndex',
        component: OrderIndex,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true, // 表示需要身份验证
        },
        children: [
            // 新增业务订单中心路由
            {
                path: 'order-list',
                name: 'OrderList',
                component: OrderList,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: true,
                }
            },
            {
                path: 'order-detail',
                name: 'OrderDetail',
                component: OrderDetail,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            // 代拿报告路由
            {
                path: 'order-report-detail',
                name: 'OrderReportDetail',
                component: OrderReportDetail,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            // 代配药路由
            {
                path: 'medicine-dispatch-detail',
                name: 'MedicineDispatchDetail',
                component: MedicineDispatchDetail,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            // 代问诊路由
            {
                path: 'inquiry-agency-detail',
                name: 'InquiryAgencyDetail',
                component: InquiryAgencyDetail,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            // 预约检查路由
            {
                path: 'appointment-check-detail',
                name: 'AppointmentCheckDetail',
                component: AppointmentCheckDetail,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            // 代办住院/出院
            {
                path: 'in-hospital-detail',
                name: 'InHospitalDetail',
                component: InHospitalDetail,
                meta: {
                    requireAuth: true
                }
            },

            // 代办入院/出院
            {
                path: 'in-hospital-in-detail',
                name: 'InHospitalInDetail',
                component: InHospitalInDetail,
                meta: {
                    requireAuth: true
                }
            },
        ]
    },
    {
        path: '/OrderDispatchIndex',
        name: 'OrderDispatchIndex',
        component: OrderDispatchIndex,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true, // 表示需要身份验证
        },
        children: [
            {
                path: 'order-detail-dispatch',
                name: 'OrderDetailDispatch',
                component: OrderDetailDispatch,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            {
                path: 'order-report-detail-dispatch',
                name: 'OrderReportDetailDispatch',
                component: OrderReportDetailDispatch,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            {
                path: 'medicine-dispatch-detail-dispatch',
                name: 'MedicineDispatchDetailDispatch',
                component: MedicineDispatchDetailDispatch,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            // 代问诊路由
            {
                path: 'inquiry-agency-detail-dispatch',
                name: 'InquiryAgencyDetailDispatch',
                component: InquiryAgencyDetailDispatch,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            // 预约检查路由
            {
                path: 'appointment-check-detail-dispatch',
                name: 'AppointmentCheckDetailDispatch',
                component: AppointmentCheckDetailDispatch,
                meta: {
                    requireAuth: true,
                    // 是否显示导航栏
                    showNav: false,
                }
            },
            {
                path: 'in-hospital-detail-dispatch',
                name: 'InHospitalDetailDispatch',
                component: InHospitalDetailDispatch,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'in-hospital-in-detail-dispatch',
                name: 'InHospitalInDetailDispatch',
                component: InHospitalInDetailDispatch,
                meta: {
                    requireAuth: true
                }
            },
        ]
    },
    {
        path: '/ManagementIndex',
        name: 'ManagementIndex',
        component: ManagementIndex,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true, // 表示需要身份验证
        },
        children: [
            {
                path: 'business-area-management',
                name: 'BusinessAreaManagement',
                component: BusinessAreaManagement,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'business-area-list',
                name: 'BusinessAreaList',
                component: BusinessAreaList,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'edit-street-management',
                name: 'EditStreetManagement',
                component: EditStreetManagement,
                meta: {
                    requireAuth: true,
                    title: '街道单位管理'
                }
            },
            {
                path: 'edit-community-management',
                name: 'EditCommunityManagement',
                component: EditCommunityManagement,
                meta: {
                    requireAuth: true,
                    title: '居委单位管理'
                }
            },
            {
                path: 'edit-res-community-management',
                name: 'EditResCommunityManagement',
                component: EditResCommunityManagement,
                meta: {
                    requireAuth: true,
                    title: '居民社区管理'
                }
            },
            {
                path: 'edit-cooperation-management',
                name: 'EditCooperationManagement',
                component: EditCooperationManagement,
                meta: {
                    requireAuth: true,
                    title: '合作机构管理'
                }
            },
            {
                path: 'edit-service-area-management',
                name: 'EditServiceAreaManagement',
                component: EditServiceAreaManagement,
                meta: {
                    requireAuth: true,
                    title: '服务责任片区设置'
                }
            },
            {
                path: 'service-charge-management',
                name: 'ServiceChargeManagement',
                component: ServiceChargeManagement,
                meta: {
                    requireAuth: true,
                    title: '服务收费管理'
                }
            },
            {
                path: 'edit-service-charge',
                name: 'EditServiceCharge',
                component: EditServiceCharge,
                meta: {
                    requireAuth: true,
                    title: '编辑服务收费'
                }
            },
            {
                path: 'equipment-charge-management',
                name: 'EquipmentChargeManagement',
                component: EquipmentChargeManagement,
                meta: {
                    requireAuth: true,
                    title: '器材收费管理'
                }
            },
            {
                path: 'edit-equipment-charge',
                name: 'EditEquipmentCharge',
                component: EditEquipmentCharge,
                meta: {
                    requireAuth: true,
                    title: '编辑器材收费'
                }
            },
            {
                path: 'service-cooperation-management',
                name: 'ServiceCooperationManagement',
                component: ServiceCooperationManagement,
                meta: {
                    requireAuth: true,
                    title: '服务合作机构管理'
                }
            },
            {
                path: 'edit-service-cooperation',
                name: 'EditServiceCooperation',
                component: EditServiceCooperation,
                meta: {
                    requireAuth: true,
                    title: '编辑服务合作机构'
                }
            },
        ]
    },
    {
        path: '/userIndex',
        name: 'UserIndex',
        component: () => import('../views/userManage/UserIndex.vue'),
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true, // 表示需要身份验证
        },
        children: [
            {
                path: 'userEdit',
                name: 'UserEdit',
                component: () => import('../views/userManage/UserEdit.vue'),
                meta: {
                    showNav: false,
                    requireAuth: true,
                }
            },
            {
                path: 'userAgreement',
                name: 'UserAgreement',
                component: () => import('../views/userManage/UserAgreement.vue'),
                meta: {
                    showNav: false,
                    requireAuth: true,
                }
            },
            {
                path: 'privacyPolicy',
                name: 'PrivacyPolicy',
                component: () => import('../views/userManage/PrivacyPolicy.vue'),
                meta: {
                    showNav: false,
                    requireAuth: true,
                }
            },
            {
                path: 'userDate',
                name: 'userDate',
                component: () => import('../views/userManage/userDate.vue'),
                meta: {
                    showNav: true,
                    requireAuth: true,
                }
            }
        ],
    },
]
const router = new VueRouter({
    // mode: 'hash',
    routes,
    scrollBehavior() {
        // to, from, savedPosition
        return { x: 0, y: 0 }
    }
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
    const openid = store.state.OPENID;
    const USERINFO = store.state.USERINFO;
    const fromEscortVerify = store.state.fromEscortVerify;
    const queryOrderId = to.query.order_id;

    // 若用户已登录，访问登录页
    if (openid && to.path === '/login') {
        if (fromEscortVerify) {
            // 清空 USERINFO、OPENID、fromEscortVerify
            store.commit('updateUserInfo', '');
            store.commit('updateOpenid', '');
            store.commit('setFromEscortVerify', false);
        } else {
            next('/home/personal');
            return;
        }
    }

    // 若用户未登录，访问需要认证的页面则重定向到登录页
    if (to.meta.requireAuth && !openid) {
        next('/login');
        return;
    }

    // 若从 escort-verify 页面进入，设置标记
    if (from.path === '/escort-verify') {
        store.commit('setFromEscortVerify', true);
    }

    // 若页面需要认证且用户已登录，获取用户信息
    if (to.meta.requireAuth && openid) {
        try {
            if (!fromEscortVerify) {
                await store.dispatch('fetchUserInfo', openid);
            }
        } catch (error) {
            console.error('获取用户信息失败，跳转登录页', error);
            next('/login'); // 修正路径大小写
            return;
        }
    }

    // 若默认打开 EscortVerify 页面
    if (openid && to.path === '/escort-verify') {
        if (USERINFO && USERINFO.order_id) {
            if (queryOrderId !== USERINFO.order_id) {
                // 链接 order_id 不存在或与 USERINFO.order_id 不相等，清空 USERINFO、OPENID、fromEscortVerify
                store.commit('updateUserInfo', '');
                store.commit('updateOpenid', '');
                store.commit('setFromEscortVerify', false);
                next();
                return;
            }

            if (USERINFO.servicecont && USERINFO.id) {
                const routeMap = {
                    '3': 'OrderReportDetailDispatch',
                    '11': 'MedicineDispatchDetailDispatch',
                    '12': 'InquiryAgencyDetailDispatch',
                    '13': 'AppointmentCheckDetailDispatch',
                    '14': 'InHospitalDetailDispatch',
                    '15': 'InHospitalInDetailDispatch'
                };
                const routeName = routeMap[USERINFO.servicecont] || 'OrderDetailDispatch';
                next({
                    name: routeName,
                    query: { id: USERINFO.id }
                });
                return;
            }
        }
    }

    // 默认放行
    next();

});

export default router